/** A property as the products store holds it (`getAllProperties`). */
export type PropertyRecord = {
  _id: string;
  name?: string;
  label?: unknown;
  description?: string;
  type?: string;
};

/** One row of a category screen's property table. */
export type PropertyRow = {
  key: string;
  added: boolean;
  label?: unknown;
  name?: string;
  description?: string;
  type?: string;
};

/**
 * SCRUM-2217: the store's properties as table rows, `added` when the id is in
 * `selectedIds`. Computed during render by both the Add and the Update category
 * screens, so neither keeps a copy of the store list in local state.
 */
export const propertyRows = (
  properties: readonly PropertyRecord[] | undefined,
  selectedIds: readonly string[]
): PropertyRow[] =>
  (properties || []).map((prop) => ({
    key: prop._id,
    added: selectedIds.includes(prop._id),
    label: prop.label,
    name: prop.name,
    description: prop.description,
    type: prop.type,
  }));
